export default function() {
  document.addEventListener("DOMContentLoaded", function () {
    const downloadsform = document.getElementById("download_filter_form");
    downloadsform?.addEventListener("submit", function (e) {
        e.preventDefault();
    });

    // Filtering
    const downloadsinput = document.getElementById("download_filter_input");

    downloadsinput?.addEventListener("keyup", function () {
        const items = document.querySelectorAll(".js-filter-downloads > div");

        items.forEach((item) => {
        if (
            item
            .getAttribute("data-download-filter")
            .toLowerCase()
            .indexOf(downloadsinput.value.toLowerCase()) > -1
        ) {
            item.style.display = "block";
        } else {
            item.style.display = "none";
        }
        });
    });
    });
}